import { filter } from 'rxjs/operators';
import {Component, OnInit} from '@angular/core';
import {FormArray, FormBuilder, FormControl, FormGroup, ValidationErrors, Validators} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {UserType} from '../../../Shared/Enums/UserType';
import {AuthService} from '../../../Shared/Services/auth.service';
import {Router} from '@angular/router';
import {LoginVm} from '../../../Model/LoginVM';
import {CostCalculationVM} from '../../../Model/cost-calculation/CostCalculationVM';
import {
  SectorProductComparisonRequestDTOVM
} from '../../../Model/cost-calculation/SectorProductComparison/SectorProductComparisonRequestDTOVM';
import {DtoProductCostVM} from '../../../Model/cost-calculation/DtoProductCostVM';
import {ShowValidationComponent} from '../../../Shared/Components/show-validation/show-validation.component';
import {SharedService} from '../../../Shared/Services/shared.service';
import {DtoCostCalcAddNameVM} from '../../../Model/cost-calculation/DtoCostCalcAddNameVM';
import {takeUntil} from 'rxjs/internal/operators/takeUntil';
import {Subject} from 'rxjs/internal/Subject';
import {NgxSpinnerService} from 'ngx-spinner';
import {CostCalculationService} from '../../../Services/cost-calculation.service';
import {CustomToastrService} from '../../../Shared/Services/custom-toastr.service';
import {DialogService} from '../../../Shared/Services/dialog.service';
import {DtoColorsVM} from "../../../Model/cost-calculation/DtoColorsVM";
import {DtoListSubVM, DtoParentSubCategoryVM} from "../../../Model/cost-calculation/DtoParentSubCategoryVM";
import {FloatLabelType} from "@angular/material/form-field";
import {KeyValue} from "@angular/common";
import {forkJoin} from "rxjs";
import {SectorsService} from "../../../Services/sectors.service";

@Component({
  selector: 'app-cost-calculation-page',
  templateUrl: './cost-calculation-page.component.html',
  styleUrl: './cost-calculation-page.component.scss'
})
export class CostCalculationPageComponent implements OnInit {
  readonly floatLabelControl = new FormControl('auto' as FloatLabelType);
  private destroy$: Subject<boolean> = new Subject<boolean>();
  ClassIndex: number = 1;
  Classes: number[] = [1];
  ParentForm: FormGroup = new FormGroup({});
  ValidationErrors: any[] = [];
  currentUser: LoginVm = {};
  AllCostCalcAddsNames: DtoCostCalcAddNameVM[] = [];
  ColorList!: DtoColorsVM[];
  AllSubCategory: DtoListSubVM[] = [];
  AllCostNames: string[] = [];
  selectedIds: number[] = [];

  DisplayOnlyPriceForClientBtn: boolean = false;
  DisplayAllBtn: boolean = false;
  HasComparePermission: boolean = false;

  DisplayPriceData: CostCalculationVM[] = [];
  SectorProductData: SectorProductComparisonRequestDTOVM = {};
  TotalCostData: CostCalculationVM[] = [];
  SectorsOrderData: DtoProductCostVM[] = [];
  HowToCutSticksData: CostCalculationVM[] = [];

  IsDisplayPrice: boolean = false;
  IsSectorProductComparison: boolean = false;
  IsGetTotalCost: boolean = false;
  IsMakeSectorsOrder: boolean = false;
  IsHowToCutSticks: boolean = false;
  Clonning: boolean = false;
  sectors: KeyValue<string, string>[] = [];
  sectorId: string | null = null;
  categoriesLoading: boolean = false;

  constructor(private translateService: TranslateService,
              private auth: AuthService, private router: Router, private dialogService: DialogService,
              private shared: SharedService, private api: CostCalculationService, private toastrService: CustomToastrService,
              private spinner: NgxSpinnerService, private formBuilder: FormBuilder, private sectorsService: SectorsService) {
  }

  ngOnInit() {
    if (this.auth.isAuthenticated([UserType.Workshop, UserType.Gallery])) {
      this.ParentForm = new FormGroup({});
      this.GetCurrentUser();
      this.GetLookups();
      this.DisplayOnlyPriceForClientBtn = UserType.Gallery == this.currentUser.userType
      this.DisplayAllBtn = UserType.Workshop == this.currentUser.userType
      this.HasComparePermission = this.currentUser.isHaveComparePerm == true;
    } else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  GetSectors() {
    return this.sectorsService.GetUserSectors();
  }

  GetLookups() {
    this.spinner.show();
    this.categoriesLoading = true;
    let requests = [
      this.GetSectors(),
      this.GetColors(),
      this.GetAllCostCalcAddsNames()
    ];
    forkJoin(requests).pipe(takeUntil(this.destroy$)).subscribe({
      next: ([sectors, colors, costCalcs]: any) => {
        this.sectors = sectors;
        if (this.sectors.length > 0) {
          this.sectorId = this.sectors[0].key ?? null;
        }
        this.ColorList = colors.payload;

        if (costCalcs.status == "success") {
          this.AllCostCalcAddsNames = costCalcs.payload;
          this.AllCostCalcAddsNames?.forEach(value => {
            this.AllCostNames.push(value.name!);
          });
        } else {
          this.toastrService.showErrorToast('Error', "SomethingWentWrong");
        }
        this.GetAllSubCategory();
      },
      error: (error: any) => {
        this.spinner.hide();
        this.toastrService.showErrorToast('Error', "SomethingWentWrong");
      }
    });
  }

  GetAllSubCategory() {
    this.AllSubCategory = [];
    this.spinner.show();
    this.categoriesLoading = true;
    return this.api.GetAllParentSubCategory(this.sectorId)
      .subscribe(
        {
          next: (data: any) => {
            if (data.status == "success") {
              this.ParentForm = new FormGroup({});
              let AllParentSubCategory = data.payload;
              AllParentSubCategory?.sort((a: DtoParentSubCategoryVM, b: DtoParentSubCategoryVM) => {
                return a?.parentCategory?.localeCompare(b?.parentCategory ?? '') ?? 0;
              }).forEach((parent: DtoParentSubCategoryVM) => {
                parent.listSub?.forEach((sub: DtoListSubVM) => {
                  if (!this.AllSubCategory.find(g => g.id == sub.id)) {
                    // if(this.sectorId == '16'|| null){
                    //   const allowed = new Set(['6', '11']);

                    //   if (sub.subCategory?.includes('6') || sub.subCategory?.includes('11')) {
                    //     this.AllSubCategory.push(sub);
                    //   }
                    // }else{
                     // this.AllSubCategory.push(sub);

                    // }
                    this.AllSubCategory.push(sub);
                  }
                });
              });
              this.AllSubCategory = this.AllSubCategory.sort((a: DtoListSubVM, b: DtoListSubVM) => {
                return a?.subCategory?.localeCompare(b?.subCategory ?? '') ?? 0;
              });
              this.AllSubCategory = [...this.AllSubCategory];
            } else {
              this.toastrService.showErrorToast('Error', "SomethingWentWrong");
            }
            this.spinner.hide();
            this.categoriesLoading = false;
          },
          error: (error: any) => {
            this.spinner.hide();
            this.toastrService.showErrorToast('Error', "SomethingWentWrong");
          }
        });
  }

  GetColors() {
    return this.api.GetColorsForWorkShop();
  }

  GetAllCostCalcAddsNames() {
    return this.api.GetAllCostCalcAddsNames();
  }

  GetParentForm(ParentForm: FormGroup) {
    this.ParentForm = ParentForm;
    if (this.Clonning) {
      this.Clonning = false;
    }
  }

  GetCurrentUser() {
    let jsonObj = this.auth.getStorage("currentUser");
    this.currentUser = <LoginVm>JSON.parse(jsonObj);
  }

  addNewDiv() {
    let newIdx = this.Classes[this.Classes.length - 1] + 1;
    this.Classes.push(newIdx);
    this.ClassIndex = this.Classes.length + 1;
  }

  cloneItem(index: number) {
    this.Clonning = true;
    this.addNewDiv();
  }

  GetErrorMsg(key: any) {
    this.translateService.get(key).subscribe((translation: any) => {
      this.ValidationErrors.push(translation);
    });
  }

  getFormValidationErrors(form: FormGroup) {
    Object.keys(form?.controls).forEach(key => {
      let splited = key.split('_')[0];
      if (this.AllCostNames.includes(splited)) {
        let controls = (form.get(key) as FormArray).controls;
        Object.keys(controls).forEach(subkey => {
          const controlErrors: ValidationErrors | null | undefined = form?.get(key)?.get(subkey)?.errors;
          if (controlErrors != null) {
            Object.keys(controlErrors).forEach(keyError => {
              if (subkey.includes("width")) {
                this.GetErrorMsg("EnterWidth");
              } else if (subkey.includes("value")) {
                this.GetErrorMsg("EnterValue");
              } else if (subkey.includes("price")) {
                this.GetErrorMsg("EnterPrice");
              } else if (subkey.includes("height")) {
                this.GetErrorMsg("EnterHeight");
              }
            });
          }
        });
      } else {
        this.shared.FireControlValidation(form, key);
      }
    });

    if (this?.ValidationErrors?.length > 0) {
      this.ValidationErrors = this.ValidationErrors.filter((el, i, a) => i === a.indexOf(el));

      this.dialogService.openDialog(ShowValidationComponent, this.ValidationErrors);
    }
  }

  BindFormGroup() {
    Object.keys(this.ParentForm?.controls).forEach(key => {
      let splited = key.split('_')[0];
      if (this.AllCostNames.includes(splited)) {
        let controls = (this.ParentForm.get(key) as FormArray).controls;
        if (controls != null) {
          if (this.ParentForm.get(key)?.value.id) {
            this.selectedIds.push(this.ParentForm.get(key)?.value.id);
          }
        }
      }
    });
  }

  AddPriceValidators(IsAdd: boolean = false) {
    if (IsAdd) {
      this.Classes.forEach((i) => {
        this.ParentForm.controls['price_' + i]?.addValidators([
          Validators.required,
        ]);
        this.ParentForm.controls['price_' + i]?.updateValueAndValidity();
      });
    } else {
      this.Classes.forEach((i) => {
        this.ParentForm.controls['price_' + i]?.removeValidators([
          Validators.required,
        ]);
        this.ParentForm.controls['price_' + i]?.updateValueAndValidity();
      });
    }
  }
  // AddPriceValidators(IsAdd: boolean = false) {
  //   if (IsAdd) {
  //     this.ParentForm.controls["price_" + this.ClassIndex]?.addValidators([Validators.required]);
  //     this.ParentForm.controls["price_" + this.ClassIndex]?.updateValueAndValidity();
  //   } else {
  //     this.ParentForm.controls["price_" + this.ClassIndex]?.removeValidators([Validators.required]);
  //     this.ParentForm.controls["price_" + this.ClassIndex]?.updateValueAndValidity();
  //   }
  // }

  //#region How To Cut Sticks
  HowToCutSticks(form: any) {
    this.ValidationErrors = [];
    this.AddPriceValidators(false);
    if (form.valid) {
      this.SubmitHowToCutSticks(form);
    } else {
      this.getFormValidationErrors(this.ParentForm);
      this.confirmValidator(form);
    }
  }

  SubmitHowToCutSticks(form: any) {
    for (let i = 0; i < this.Classes.length; i++) {
      let idx = this.Classes[i];
      let Product: CostCalculationVM = this.api.GetCostCalculationData(form, idx, this.AllCostNames);
      this.GetCategoryImage(Product);
      this.HowToCutSticksData?.push(Product);
    }

    this.IsHowToCutSticks = true;
  }

  CheckIsHowToCutSticks(IsHowToCutSticks: boolean) {
    // this.BindFormGroup();
    this.HowToCutSticksData = [];
    this.IsHowToCutSticks = IsHowToCutSticks;
  }

  //#endregion

  //#region Make Sectors Order
  MakeSectorsOrder(form: any) {
    this.ValidationErrors = [];
    this.AddPriceValidators(false);
    if (form.valid) {
      this.MakeOrder(form);
    } else {
      this.getFormValidationErrors(form);
      this.confirmValidator(form);
    }
  }

  MakeOrder(form: any) {
    for (let i = 0; i < this.Classes.length; i++) {

      let idx = this.Classes[i];
      let Product: DtoProductCostVM = this.api.GetDtoProductCost(form, idx);
      this.SectorsOrderData?.push(Product);
    }

    this.IsMakeSectorsOrder = true;
  }

  CheckIsMakeSectorsOrder(IsMakeSectorsOrder: boolean) {
    // this.BindFormGroup();
    this.SectorsOrderData = [];
    this.IsMakeSectorsOrder = IsMakeSectorsOrder;
  }

  //#endregion

  //#region Display Price For Client
  DisplayPriceForClient(form: any) {
    this.ValidationErrors = [];
    this.AddPriceValidators(true);
    if (form.valid) {
      this.DisplayPrice(form);
    } else {
      this.getFormValidationErrors(form);
      this.confirmValidator(form);
    }
  }

  DisplayPrice(form: any) {
    this.DisplayPriceData = this.GetSelectedData(form);
    this.IsDisplayPrice = true;
  }

  GetSelectedData(form?: any): CostCalculationVM[] {
    let dataList: CostCalculationVM[] = [];
    for (let i = 0; i < this.Classes.length; i++) {
      let idx = this.Classes[i];
      let data: CostCalculationVM = this.api.GetCostCalculationData(form, idx, this.AllCostNames);
      this.GetCategoryImage(data);
      dataList.push(data);
    }

    return dataList;
  }

  CheckIsDisplayPrice(IsDisplayPrice: boolean) {
    // this.BindFormGroup();
    this.DisplayPriceData = [];
    this.IsDisplayPrice = IsDisplayPrice;
    this.AddPriceValidators(false);
  }

  //#endregion

  //#region Sector Product Comparison
  SectorProductComparison(form: any) {
    this.ValidationErrors = [];
    this.AddPriceValidators(false);
    if (form.valid) {
      this.SectorComparison(form);
    } else {
      this.getFormValidationErrors(this.ParentForm);
      this.confirmValidator(form);
    }
  }

  SectorComparison(form: any) {
    this.SectorProductData = this.GetSelectedProduct(form);
    this.IsSectorProductComparison = true;
  }

  GetSelectedProduct(form?: any): SectorProductComparisonRequestDTOVM {
    let SectorProductData: SectorProductComparisonRequestDTOVM = {
      Products: [],
      SectorIds: []
    };

    for (let i = 0; i < this.Classes.length; i++) {
      let idx = this.Classes[i];
      let Product: DtoProductCostVM = this.api.GetDtoProductCost(form, idx);
      SectorProductData.Products?.push(Product);
    }

    return SectorProductData;
  }

  CheckIsSectorProductComparison(IsSectorProductComparison: boolean) {
    // this.BindFormGroup();
    this.SectorProductData = {};
    this.IsSectorProductComparison = IsSectorProductComparison;
  }

  //#endregion

  //#region Cost Calculation
  CostCalculation(form: any) {

    this.ValidationErrors = [];
    this.AddPriceValidators(false);
    if (form.valid) {
      this.GetAllTotalCost(form);
    } else {
      this.getFormValidationErrors(this.ParentForm);
      this.confirmValidator(form);
    }
  }

  GetAllTotalCost(form: any) {

    this.TotalCostData = this.GetTotalCostData(form);
    this.IsGetTotalCost = true;
  }

  GetTotalCostData(form: any): CostCalculationVM[] {
    let dataList: CostCalculationVM[] = [];
    for (let i = 0; i < this.Classes.length; i++) {
      let idx = this.Classes[i];
      let data: CostCalculationVM = this.api.GetCostCalculationData(form, idx, this.AllCostNames);
      this.GetCategoryImage(data);
      dataList.push(data);
    }

    return dataList;
  }

  CheckIfIsTotalCost(IsGetTotalCost: boolean) {

    this.TotalCostData = [];
    this.IsGetTotalCost = IsGetTotalCost;
  }

  GetCategoryImage(data: CostCalculationVM): void {
    let category = this.AllSubCategory.filter(s => s.id === data.subCategoryId).at(0);
    if (category) {
      data.subCategoryImage = category.filePath;
    }
  }

  //#endregion

  get SectorName(): string | null {
    return this.sectors.filter(s => s.key === this.sectorId)[0]?.value ?? null;
  }

  changeSector(key: string) {
    this.sectorId = key;
    this.spinner.show();
    this.categoriesLoading = true;
    this.GetAllSubCategory();
  }
confirmValidator(form: FormGroup) {
    let errors = [];

    for (let control in form.value) {
      if (
        form.value[control] === null ||
        form.value[control] === '' ||
        form.value[control] === undefined
      ) {
        errors.push(control[control.length - 1] + `  صنف  `);
      }
    }
    errors = [...new Set(errors)];
    this.dialogService.confirmDialog({
      titleKey: 'برجاء التحقق من البيانات التالية',
      messageKey: `${errors.join('\n')} `,
      confirmTextKey: 'confirm',
    });
  }

}
